<template>
  <With_Header_Modal_Template title="Детали записи">
    <div class="details">
      <div class="details_content">
        <custom-input placeholder="Название" mb="15px"/>
        <custom-input placeholder="Цена" mb="15px"/>
        <custom-input mb="15px"/>
        <custom-input mb="15px"/>
        <custom-input mb="15px"/>
        <div class="time_picker">
          <custom-input type="time"/>
          <span class="line_between">—</span>
          <custom-input type="time"/>
        </div>
        <!-- red || brown || green -->
        <div class="text_desc red">забронировано неподходящее рабочее место</div>
        <div class="line"></div>
        <div class="master">
          <img src="../../../../assets/images/main/chat/avatar2.png" alt="">
          <div class="master_info">
            <div class="master_title">Екатерина Юнусова</div>
            <div class="master_phone">+7 (927) 815-99-23</div>
          </div>
        </div>
        <ButtonComponent variant="outlined" width="100%">Чат</ButtonComponent>
      </div>
      <div class="details_bottom">
        <ButtonComponent variant="filled" width="100%">Редактировать</ButtonComponent>
      </div>
    </div>
  </With_Header_Modal_Template>
</template>

<script>
import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'
import CustomInput from '@/components/ui/inputs/custom-input'
import ButtonComponent from '@/components/ui/buttons/button-component'

export default {
  name: "DetailsOfRecording",
  components: {ButtonComponent, CustomInput, With_Header_Modal_Template}
}
</script>

<style scoped lang="scss">
.details {
  padding: 20px 15px;

  &_content {
    height: calc(100vh - 170px);
    margin-bottom: 20px;
    overflow: auto;
  }
}

.text_desc {
  font-weight: 600;
  font-size: 12px;
  line-height: 1.67;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 20px 0;
  &.red {
    color: #E05252;
  }
  &.green {
    color: #0F8A84;
  }
  &.brown {
    color: #b9765b;
  }
}

.line {
  background-color: #DBBFA7;
  height: 1px;
  width: 100%;
  margin-bottom: 15px;
}

.master {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
  }
  &_title {
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
    color: #383838;
  }
  &_phone {
    font-size: 14px;
    line-height: 1.71;
    color: #808080;
  }
}

.time_picker {
  display: flex;
  align-items: center;
  .line_between {
    margin: 0 7px;
  }
}

</style>
